module.exports = __webpack_public_path__ + "static/media/52654473_2452987541443089_1575101491130138624_o.e31b3231.jpg";